import type { ProjectAnnotationsSort } from "../types"

export const DEFAULT_PROJECT_ANNOTATIONS_SORT: ProjectAnnotationsSort = {
  field: "LABEL_TIME",
  direction: "DESC",
}

export function normalizeProjectAnnotationsSort(
  value: unknown,
): ProjectAnnotationsSort | undefined {
  if (
    typeof value !== "object" ||
    value === null ||
    Array.isArray(value) ||
    Object.keys(value).some((key) => key !== "field" && key !== "direction")
  ) {
    throw new Error("human_review_view: sort is invalid")
  }
  const sort = value as Record<string, unknown>
  if (
    (sort.field !== "LABEL_TIME" && sort.field !== "CONVERSATION_TIME") ||
    (sort.direction !== "ASC" && sort.direction !== "DESC")
  ) {
    throw new Error("human_review_view: sort is invalid")
  }
  return sort.field === DEFAULT_PROJECT_ANNOTATIONS_SORT.field &&
    sort.direction === DEFAULT_PROJECT_ANNOTATIONS_SORT.direction
    ? undefined
    : { field: sort.field, direction: sort.direction }
}
